import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveDocumentContent } from "../services/document.service";
import type { ISaveDocumentContent } from "../types/document.types";

export const useUpdateDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ISaveDocumentContent) => saveDocumentContent(data),
    onSuccess: () => {
      // Invalidate and refetch document data
      queryClient.invalidateQueries({ queryKey: ["document"] });
    },
    onError: (error) => {
      console.error("Failed to update document:", error);
    },
  });
};
